import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppBrokerComponent } from './app-broker/app-broker.component';
import { appBrokerConfig } from './app-broker/app-broker.config';
import { environment } from './environments/default/environment';
import { AppComponent } from './app/app.component';
import { PurpleStringExtensions } from '@purple-lib/purple-utilities';


if (!environment.BROKER_ENABLED) {
  localStorage.setItem("ApiBasePath", environment.API_BASE_PATH)
}

const basePath = localStorage.getItem("ApiBasePath");

const setTheme = () => {
  const title = document.createElement('title');
  title.innerText = PurpleStringExtensions.isNullOrEmpty(environment.COMPANY_NAME) ? "PurpleFit Booking" : environment.COMPANY_NAME;
  document.head.appendChild(title)

  const meta1 = document.createElement('meta');
  meta1.name = "msapplication-TileColor";
  meta1.content = PurpleStringExtensions.isNullOrEmpty(environment.HTML_TITLE_COLOR) ? "#000000" : environment.HTML_TITLE_COLOR;
  document.head.appendChild(meta1)

  const meta2 = document.createElement('meta');
  meta2.name = "theme-color";
  meta2.content = PurpleStringExtensions.isNullOrEmpty(environment.HTML_THEME_COLOR) ? "#000000" : environment.HTML_THEME_COLOR;
  document.head.appendChild(meta2)

  const meta3 = document.createElement('meta');
  meta3.name = "apple-mobile-web-app-title";
  meta3.content = environment.COMPANY_NAME;
  document.head.appendChild(meta3)
}


const setMonacoEditor = () =>{
  (window as any).MonacoEnvironment = {
    getWorkerUrl: function (_moduleId: string) {
      return './assets/vs/base/worker/workerMain.js';
    }
  };
}

if (basePath != undefined && basePath) {
  bootstrapApplication(AppComponent, appConfig).then(() => {
    setTheme();
    setMonacoEditor();
  }).catch((err) => console.error(err));
} else {
  bootstrapApplication(AppBrokerComponent, appBrokerConfig).then(() => {
    setTheme();
  }).catch((err) => console.error(err));
}